module.exports = __webpack_public_path__ + "static/media/CADSII.762e0e1d.png";